import { useState, useEffect } from "react";
import { APP_NAME } from "../../config";

export default function setTitle(title) {
  const pageTitle = !!title ? ` - ${title}` : "";
  document.title = APP_NAME + pageTitle;
}

export function usePageTitle(t) {
  const [title, setTitle] = useState(t);

  useEffect(() => {
    const pageTitle = !!title ? ` - ${title}` : "";
    document.title = APP_NAME + pageTitle;
  }, [title]);


  return setTitle;
}